import { actions } from '../../../../redux'
import { FullDeclaration, MemberProps, MemberReturn } from '../../../../types'

export const usePartner = (props: MemberProps): MemberReturn => {
  const { t, dispatch, formValues, fullName } = props

  const declarations = (formValues?.partner?.items as FullDeclaration[]) || []

  const handleAddDeclaration = (values: any) => {
    dispatch(
      actions.declaration.appendPartnerDeclarationItem({
        ...values,
        id: declarations.length,
      })
    )
  }

  const handleUpdateDeclaration = (i: number, values: any) => {
    dispatch(
      dispatch(
        actions.declaration.updatePartnerDeclarationItem({
          index: i,
          item: values,
        })
      )
    )
  }

  const handleDeleteDeclaration = (i: number) => {
    dispatch(actions.declaration.removePartnerDeclarationItem(i))
  }

  const handleAddMember = (values: any) => {
    dispatch(actions.declaration.setPartner(values))
  }

  const handleResetDeclaration = () => {
    dispatch(actions.declaration.resetPartner())
  }

  return {
    declarations,
    addDeclaration: handleAddDeclaration,
    updateDeclaration: handleUpdateDeclaration,
    deleteDeclaration: handleDeleteDeclaration,
    addMember: handleAddMember,
    addAnotherChild: {},
    resetMember: handleResetDeclaration,
    addMemberInitialValues: {
      hasMemberToDeclare: formValues.partner?.hasMemberToDeclare || '1',
      civility: formValues.partner?.civility || '',
      lastName: formValues.partner?.lastName || '',
      firstName: formValues.partner?.firstName || '',
    },
    addDeclarationStepPartText: t('declaration.form.stepPart.partnerDeclaration'),
    addDeclarationLabel: t('declaration.from.addDeclaration.label.partner'),
    declarationListStepPartText: t('declaration.form.stepPart.partnerDeclaration'),
    declarationListLabel: t('declaration.form.declarationList.label', {
      name: fullName,
      type: t('declaration.partner'),
    }),
    addMemberStepPartText: t('declaration.form.stepPart.partnerDeclaration'),
    addMemberLabel: t('declaration.form.addMember.label.partner'),
    typeOfAdd: 'partner',
  }
}
